<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-tabs>
      <v-tab>Geral</v-tab>
      <v-tab>
        Endereço
        <v-tooltip top v-if="addressError">
          <template v-slot:activator="{ on }">
            <v-icon 
              right 
              color="error"
              v-on="on"
            >
              mdi-alert-circle-outline
            </v-icon>
          </template>
          <span>Existem erros no cadastro do endereço da área que devem ser resolvidos!</span>
        </v-tooltip>
      </v-tab>
      <v-tab>Logo</v-tab>
    
      <v-tab-item>
        <v-row>
          <v-col cols="12" md="3">
            <v-radio-group 
              v-model="entry.type"
              v-bind="getObject('type')"
              :disabled="readOnly"
              >
              <template v-slot:label>
                <div>Tipo de Área</div>
              </template>
              <v-radio 
                value="OwnedGround"
                @change="entry.rentalPrice = null"
              >
                <template v-slot:label>
                  <div>Área Própria</div>
                </template>
              </v-radio>
              <v-radio 
                value="RentedGround"
                @change="entry.price = entry.opportunityCost = null"
              >
                <template v-slot:label>
                  <div>Área Arrendada</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
          
          <v-col cols="12" md="9">
            <v-row>
              <v-col cols="12" sm="12" md="8">
                <v-text-field
                  v-model="entry.name"
                  v-bind="getObject('name')"
                  label="Nome"
                  autocomplete="off"
                  :disabled="readOnly"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-switch 
                  v-model="entry.enabled" 
                  inset 
                  :label="entry.enabled ? 'Ativo' : 'Inativo'"
                  :disabled="readOnly">
                </v-switch>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <MaskedTextField
                  v-bind="getObject('area')"
                  :inputData.sync="entry.area"
                  mask-type="currency"
                  label="Área"
                  suffix="ha"
                  autocomplete="off"
                  :disabled="readOnly"
                />
              </v-col>

              <v-col cols="12" sm="8" md="6"
                v-if="entry.type == 'OwnedGround'">
                <MaskedTextField
                  v-bind="getObject('price')"
                  :inputData.sync="entry.price"
                  mask-type="currency"
                  label="Valor da Área"
                  prefix="R$"
                  :key="entry.type"
                  autocomplete="off"
                  :disabled="readOnly"
                />
              </v-col>

              <v-col cols="12" sm="8" md="6"
                v-if="entry.type == 'RentedGround'">
                <MaskedTextField
                  v-bind="getObject('rentalPrice')"
                  :inputData.sync="entry.rentalPrice"
                  mask-type="currency"
                  label="Valor do Arrendamento"
                  prefix="R$"
                  :key="entry.type"
                  autocomplete="off"
                  :disabled="readOnly"
                />
              </v-col>

              <v-col cols="12" sm="8" md="6"
                v-if="entry.type == 'OwnedGround'">
                <MaskedTextField
                  v-bind="getObject('opportunityCost')"
                  :inputData.sync="entry.opportunityCost"
                  mask-type="currency"
                  label="Custo de Oportunidade"
                  prefix="R$"
                  :key="entry.type"
                  autocomplete="off"
                  :disabled="readOnly"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item eager>
        <v-row>
          <v-col cols="12">
            <AddressForm
              ref="addressForm"
              :entry="entry.addressAttributes"
              :extraData="extraData"
              :readOnly="readOnly"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item eager>
        <v-row>
          <v-col cols="12" md="6">
            <v-file-input
              v-model="logoFile"
              label="Logo (SVG)"
              accept=".svg,image/svg+xml"
              :error-messages="logoError"
              :disabled="readOnly"
              clearable
              @change="onLogoSelected"
            />
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center">
            <v-btn
              v-if="entry.id"
              outlined
              class="ma-1 d-none d-md-flex"
              color="primary"
              :loading="logoLoading"
              :disabled="logoLoading"
              @click="loadGroundLogo"
            >
              Carregar logo atual
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="logoPreview">
          <v-col cols="12">
            <div class="d-flex justify-center align-center">
              <v-img
              :src="logoPreview"
              alt="Pré-visualização da logo"
              max-width="300"
              contain
              />
            </div>
          </v-col>
        </v-row>
      </v-tab-item>

    </v-tabs>

  </v-form>
</template>

<script>
import gql from "graphql-tag";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import AddressForm from "@models/addresses/form.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      addressError: false,
      pageLoading: false,
      logoFile: null,
      logoPreview: null,
      logoError: null,
      logoLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    AddressForm: AddressForm,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    loadGroundLogo: function() {
      this.logoError = null;
      this.logoPreview = null;
      this.logoLoading = true;

      this.$apollo
        .query({
          query: LOAD_GROUND_LOGO_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: this.entry.id
          }
        })
        .then(response => {
          const logo = response.data.accountContext.ground.logo;
          if (!logo) {
            this.logoError = "Esta área não possui uma logo cadastrada.";
            return;
          }

          this.logoPreview = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(logo)}`;
        })
        .catch(error => {
          console.error(error);
          this.logoError = "Não foi possível carregar a logo da área.";
        })
        .finally(() => {
          this.logoLoading = false;
        });
    },
    onLogoSelected: function(file) {
      this.logoError = null;
      this.logoPreview = null;

      if (!file) return;

      if (!/\.svg$/i.test(file.name) || (file.type && file.type !== "image/svg+xml")) {
        this.logoFile = null;
        this.logoError = "Selecione um arquivo no formato SVG.";
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          this.logoPreview = reader.result;
          this.entry.logoFile = this.logoPreview; // Assign the base64 string to entry.logo
        } else {
          this.logoError = "Não foi possível carregar a imagem SVG.";
        }
      };
      reader.onerror = () => {
        this.logoError = "Não foi possível carregar a imagem SVG.";
      };
      reader.readAsDataURL(file);
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        if (this.$refs.addressForm.isFormValid()) {
          this.addressError = false;
        } else {
          this.addressError = true;          
          setTimeout(function(){
            document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 500);
          return false;
        }
      } else {
        this.addressError = false;

        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);

        return false;
      }
      return true;
      // return this.$refs.form.validate() && this.$refs.addressForm.isFormValid();
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};

const LOAD_GROUND_LOGO_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      ground(id: $id) {
        logo
      }
    }
  }
`;
</script>

<style scoped></style>
